<template>
  <div>
    <div class="pc">
      <div class="content">
        <div class="main">
          <img
            class="logo"
            @click="skip('/')"
            src="@/assets/pcImg/logo-white.png"
            alt=""
          />

          <div class="card">
            <div class="title">लॉगिन</div>
            <input
              type="text"
              placeholder="इमेल आईडी"
              v-model="loginForm.userName"
            />

            <input
              :type="inputType"
              placeholder="पासवर्ड"
              v-model="loginForm.password"
            />
            <img
              class="password-close"
              :src="eyes"
              alt=""
              @click="changeEyes"
            />
            <div class="forgot" @click="skip('/forgot')">पासवर्ड भूल गए?</div>
            <div class="sign-up" @click="login">लॉगिन</div>
            <div class="account" @click="skip('/logon')">
              <div>क्या आपका खाता नहीं है?</div>
              <div>अभी पंजीकरण करें</div>
            </div>
          </div>

          <div class="foot">
            <div class="info">
              <div @click="skip('/privacyClauses/1')">उपयोग की शर्तें</div>
              <div @click="skip('/privacyClauses/2')">गोपनीयता नीति</div>
              <div @click="skip('/aboutQuestionnaire')">कैसे उपयोग करें</div>
              <div @click="skip('/helpFeedback')">अनेक प्रश्न पूछे</div>
            </div>
            <div class="copyright">copyright@2023@weopinions.com</div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile">
      <div class="mobile-content">
        <div class="mobile-main">
          <div class="imgs">
            <img
              class="fallback"
              @click="goback"
              src="@/assets/pcImg/fallback.png"
              alt=""
            />
            <img
              class="logo"
              @click="skip('/')"
              src="@/assets/pcImg/logo-white.png"
              alt=""
            />
          </div>
          <div class="text">हैलो!</div>
          <div class="text">आपसे मिलकर खुशी हुई</div>
          <div class="inputs">
            <div class="line-input">
              <img
                class="input-icon"
                src="@/assets/pcImg/emali.png"
                alt="图标"
              />
              <input
                type="text"
                v-model="loginForm.userName"
                placeholder="इमेल"
              />
            </div>

            <div class="line-input">
              <img
                class="input-icon"
                src="@/assets/pcImg/Password.png"
                alt="图标"
              />
              <input
                :type="modelType"
                v-model="loginForm.password"
                placeholder="पासवर्ड"
              />
              <img
                class="eye-icon"
                @click="changeModelEyes"
                :src="modelEyes"
                alt="图标"
              />
            </div>
          </div>
          <div class="forgot" @click="skip('/forgot')">पासवर्ड भूल गए?</div>
          <button class="submit" @click="login">सबमिट करें</button>
          <div class="account" @click="skip('/logon')">
            <div>क्या आपका खाता नहीं है?</div>
            <div>अभी पंजीकरण करें</div>
          </div>
        </div>
        <div class="mobile-foot">
          <div @click="skip('/privacyClauses/1')">उपयोग की शर्तें</div>
          <div @click="skip('/privacyClauses/2')">गोपनीयता नीति</div>
          <div @click="skip('/aboutQuestionnaire')">कैसे उपयोग करें</div>
          <div @click="skip('/helpFeedback')">अनेक प्रश्न पूछे</div>
          <div class="mobile-copyright">copyright@2023@weopinions.com</div>
        </div>
      </div>
    </div>
    <div class="mask"></div>
  </div>
</template>
<script>
import { Notify } from "vant";
import { login as authLogin, accounts } from "@/api/api.js";
export default {
  data() {
    return {
      checked: true,
      inputType: "password",
      eyes: require("@/assets/pcImg/close-eyes.png"),
      modelType: "password",
      modelEyes: require("@/assets/pcImg/close-eyes.png"),
      isSign: true,
      loginForm: {
        userName: "",
        password: "",
      },
    };
  },
  methods: {
    // 跳转
    skip(url) {
      this.$router.push({
        path: url,
      });
    },
    goback() {
      this.$router.go(-1);
    },
    // 登录点击眼睛切换
    changeEyes() {
      if (this.inputType === "password") {
        this.inputType = "text";
        this.eyes = require("@/assets/pcImg/open-eyes.png");
        return;
      }
      if (this.inputType === "text") {
        this.inputType = "password";
        this.eyes = require("@/assets/pcImg/close-eyes.png");
        return;
      }
    },
    // 手机端
    changeModelEyes() {
      if (this.modelType === "password") {
        this.modelType = "text";
        this.modelEyes = require("@/assets/pcImg/open-eyes.png");
        return;
      }
      if (this.modelType === "text") {
        this.modelType = "password";
        this.modelEyes = require("@/assets/pcImg/close-eyes.png");
        return;
      }
    },
    //登录
    async login() {
      let params = this.loginForm;
      await authLogin(params).then((res) => {
        if (res.code === 200) {
          Notify({
            type: "primary",
            message: this.$t("rigisterPage.loginSuccessed"),
          });
          localStorage.setItem("LOGIN_INFO", JSON.stringify(res.data));
          this.getAccountInfo(res.data.id);
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },
    //跳转
    async getAccountInfo(id) {
      await accounts({ id }).then((res) => {
        if (res.code === 200) {
          if (res.data.isBlacklist) {
            this.$router.push("/mine");
          } else {
            this.$router.push("/questionnaire");
          }
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },
  },
  created() {
    // 判断是否是全屏显示

    document.title =
      "Login Weopinions description: Login to the Weopinions member zone.";
  },
  beforeDestroy() {
    localStorage.setItem("questionnaireItem", 0);
  },
};
</script>
<style scoped>
/*pc端 */
.content {
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
  background-image: url("../assets/pcImg/bg.jpg");
  background-size: cover;
  background-position: 50% 70%;
}
.mask {
  background-color: rgba(0, 0, 0, 0.4);
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9;
}
.main {
  position: relative;
  width: 100%;
  z-index: 99;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.logo {
  width: 180.625px;
  height: 35.625px;
  margin-top: 82.5px;
  cursor: pointer;
}
.card {
  position: relative;
  width: 187.5px;
  height: 301.875px;
  padding-left: 43.5px;
  padding-right: 43.75px;
  background: #ffffff;
  border-radius: 6.25px;
  margin-top: 32.5px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.card .title {
  font-size: 15px;
  font-weight: 500;
  color: #232323;
  margin-top: 21.25px;
}
.card input {
  width: calc(100% - 54.25px);
  height: 25px;
  opacity: 1;
  border: 0.625px solid #dddddd;
  margin-top: 15.625px;
  padding-left: 16.25px;
  padding-right: 38px;
  font-size: 10px;
  font-weight: 400;
  color: #999999;
}

.card .password-close {
  position: absolute;
  width: 15px;
  height: 15px;
  top: 100px;
  right: 50.625px;
  cursor: pointer;
}
.card .forgot {
  width: 100%;
  font-size: 8.75px;
  margin-top: 10px;
  text-align: right;
  color: #acaac5;
  cursor: pointer;
}
.card .account {
  font-size: 8.75px;
  width: 100%;
  color: #acaac5;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.card .confirm-close {
  position: absolute;
  width: 15px;
  height: 15px;
  top: 183px;
  right: 50.625px;
  cursor: pointer;
}
.card button {
  width: 100%;
  margin: 0;
  padding: 0;
}
.sign-up {
  width: 100%;
  height: 25px;
  border-radius: 25px;
  line-height: 25px;
  background-color: #2e67ea;
  text-align: center;
  color: #fff;
  font-size: 10px;
  margin-top: 20px;
  cursor: pointer;
}
.agree {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  font-size: 8.75px;
  margin-top: 18.75px;
}
.agree > .box {
  width: 9.375px;
  height: 9.375px;
  background-color: #2e67ea;
  border-radius: 2px;
  margin-right: 10.625px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.check {
  width: 5px;
  height: 5px;
}
.agree > p {
  cursor: pointer;
}

/* 页脚 */
.foot {
  margin-top: 71.875px;
  margin-bottom: 24.375px;
  font-size: 8.75px;
  color: #fff;
}
.foot > .info {
  display: flex;
}
.info > div {
  border-right: 1px solid #fff;
  padding-right: 21.25px;
  padding-left: 21.25px;
}
.info > div:last-child {
  border-right: none;
}
.copyright {
  width: 100%;
  text-align: center;
  margin-top: 17.5px;
}
</style>
<style scoped>
/* 移动端 */
.mobile {
  display: none;
}

.mobile-content {
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
  background-image: url("../assets/pcImg/bg.jpg");
  background-size: cover;
  background-position: 50% 70%;
}
.mobile-main {
  position: relative;
  width: 100%;
  z-index: 99;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.mobile-main > .imgs {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 27.5px;
  margin-bottom: 73.75px;
}
.mobile-main > .imgs > .fallback {
  position: absolute;
  left: 18.75px;
  width: 25px;
  height: 25px;
  cursor: pointer;
}
.mobile-main > .imgs > .logo {
  margin: 0 auto;
  width: 232.5px;
  height: 46.25px;
}
.mobile-main > .text {
  width: calc(100% - 45px);
  font-size: 30px;
  color: #ffffff;
  margin-left: 22.5px;
  margin-bottom: 20px;
}
.inputs {
  width: calc(100% - 45px);
  margin-left: 22.5px;
  /* margin-right: 22.5px; */
}
.line-input {
  width: 100%;
  position: relative;
  margin-top: 10px;
}
.line-input > input {
  width: calc(100% - 137.5px);
  height: 50px;
  padding-left: 75px;
  padding-right: 40px;
  font-size: 17.5px;
  color: #999999;
}
.line-input .input-icon {
  position: relative;
  top: 39px;
  left: 20px;
  width: 25px;
  display: block;
}
.line-input .eye-icon {
  position: absolute;
  top: 39px;
  right: 30px;
  width: 25px;
  display: block;
}
.mobile-main > .forgot {
  width: calc(100% - 68px);
  text-align: right;
  color: #fff;
  font-size: 15px;
  margin-top: 20px;
  cursor: pointer;
}
.mobile-main > .account {
  width: calc(100% - 68px);
  display: flex;
  justify-content: space-around;
  color: #fff;
  font-size: 15px;
  margin-top: 30px;
  cursor: pointer;
}
.mobile-main > .account > div:first-child {
  text-align: left;
}
.mobile-main > .account > div:last-child {
  text-align: right;
}
.mobile-main .submit {
  width: calc(100% - 67.5px);
  height: 50px;
  background-color: #3d66e2;
  color: #fff;
  font-size: 17.5px;
  border-radius: 50px;
  margin-top: 41.25px;
  cursor: pointer;
}
.mobile-main .mobile-p {
  width: calc(100% - 67px);
  color: #fff;
  font-size: 15px;
  line-height: 25px;
  margin-top: 13.75px;
}
.mobile-foot {
  position: relative;
  width: 100%;
  text-align: center;
  color: #fff;
  font-size: 15px;
  z-index: 999;
  margin-top: 95px;
  padding-bottom: 9.375px;
}
.mobile-foot > div {
  margin-bottom: 11.25px;
  cursor: pointer;
}
.mobile-copyright {
  margin-top: 51.25px;
}
.line-input > .send {
  position: absolute;
  width: 180px;
  right: 30px;
  padding: 0;
  margin: 0;
  background-color: #fff;
  height: 50px;
  color: #3d66e2;
  font-size: 17.5px;
  text-align: right;
}
</style>
<style scoped>
/* 媒体查询 */
@media only screen and (max-width: 768px) {
  .pc {
    display: none;
  }
  .mobile {
    display: block;
  }
}
/* 兼容 */
input::-ms-reveal {
  display: none;
}
input::-ms-clear {
  display: none;
}
input::-o-clear {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/login.vue